import _pt from "prop-types";
import { alpha } from '@material-ui/core';
import Popover from '@material-ui/core/Popover';
import withStyles from '@material-ui/core/styles/withStyles';
import clsx from 'clsx';
import React, { useCallback } from 'react';
import useAutoclose from '../useAutoclose';
import { addClassName, capitalize } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const componentConfig = {
  name: 'MuiOriFeedbackNotification'
};

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(5, 6, 6, 6),
    backdropFilter: 'blur(3px)',
    top: '50%',
    left: '50%',
    outline: 0,
    alignItems: 'center',
    minWidth: 150,
    minHeight: 130
  },
  wide: {
    flexDirection: 'row',
    justifyItems: 'center',
    padding: theme.spacing(4, 8),
    minHeight: 'unset',
    '& $message': {
      margin: theme.spacing(0, 0, 0, 2),
      fontSize: 14
    },
    '& $icon': {
      fontSize: 30
    }
  },
  icon: {
    fontSize: 48
  },
  message: {
    margin: theme.spacing(1, 0, 0),
    fontSize: 20
  },
  fontInherit: {
    fontSize: 'inherit'
  },
  colorInitial: {
    backgroundColor: alpha(theme.palette.grey['900'], 0.8),
    color: theme.palette.common.white
  },
  colorError: {
    backgroundColor: alpha(theme.palette.error.light, 0.8),
    color: theme.palette.common.white
  },
  colorWarning: {
    backgroundColor: alpha(theme.palette.warning.main, 0.8),
    color: theme.palette.text.secondary
  },
  colorInfo: {
    backgroundColor: alpha(theme.palette.info.main, 0.8),
    color: theme.palette.common.white
  },
  colorSuccess: {
    backgroundColor: alpha(theme.palette.success.main, 0.8),
    color: theme.palette.common.white
  }
});

export const FeedbackNotification = props => {
  const {
    open,
    children,
    onClose,
    icon,
    timeoutMs = 2000,
    ref,
    color = 'initial',
    className,
    wide,
    openOnMount,
    PopoverProps = {},
    classes,
    ...divProps
  } = props;
  const handleClose = useCallback(() => {
    onClose == null ? void 0 : onClose();
  }, [onClose]);
  useAutoclose({
    onClose: handleClose,
    open,
    timeoutMs,
    autoClose: true
  });
  const message = wide ? children : addClassName(children, classes.fontInherit);
  return /*#__PURE__*/_jsxs(Popover, {
    classes: {
      paper: clsx(classes.root, classes[`color${capitalize(color)}`], className, wide && classes.wide)
    },
    PaperProps: {
      ref: ref,
      style: {
        transform: 'translate(-50%, -50%)'
      },
      ...divProps
    },
    anchorEl: document.body,
    anchorOrigin: {
      vertical: 'center',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'center',
      horizontal: 'center'
    },
    ...PopoverProps,
    open: open,
    onClose: handleClose,
    children: [/*#__PURE__*/_jsx("div", {
      className: classes.icon,
      children: addClassName(icon, classes.fontInherit)
    }), /*#__PURE__*/_jsx("div", {
      className: classes.message,
      children: message
    })]
  });
};
FeedbackNotification.propTypes = {
  wide: _pt.bool,
  timeoutMs: _pt.number,
  color: _pt.oneOf(['error', 'info', 'initial', 'success', 'warning']),
  icon: _pt.element,
  open: _pt.bool.isRequired,
  onClose: _pt.func,
  openOnMount: _pt.bool
};
export default withStyles(styles, componentConfig)(FeedbackNotification);